import { createSelector } from '@ngrx/store';
import { getMultipleOrderOnlineState } from '../reducers';
import { _safe } from '@ordersnproducts/modules/shared/utils/safe-get.method';

import { selectActiveShipmentLocationId } from 'app/shared/upload-document/redux/selectors/shipment-location.selector';

export const shipmentLocationWorksheetsState = createSelector(getMultipleOrderOnlineState, state => state.shipmentLocationWorksheets);

export const selectWorksheetByShipmentLocation = createSelector(
  shipmentLocationWorksheetsState,
  selectActiveShipmentLocationId,
  (state, activeShipmentLocationId) => state.entities[activeShipmentLocationId],
);

export const selectActiveWorksheet =  createSelector(
  shipmentLocationWorksheetsState,
  (state) => {
    return state.entities[state.activeEntityId];
  },
);

export const selectCutOffAndCalendarResponse = createSelector(
  shipmentLocationWorksheetsState,
  state => {
    return {
      cutOffResponse: state.cutOffResponse,
      calendarResponse: state.calendarsResponse,
    };
  },
);

export const selectCalendarResponse = createSelector(
  shipmentLocationWorksheetsState, state => _safe(() => state.calendarsResponse),
);


export const selectJobSiteSalesAreas = createSelector(
  shipmentLocationWorksheetsState, state => _safe(() => state.jobsiteSalesAreas),
);

export const selectPurchaseOrderValidation = createSelector(
  selectJobSiteSalesAreas, state => _safe(() => _safe(() => state.jobsiteSalesAreas[0].purchaseOrderValidation), false),
);

export const selectCutOffResponse = createSelector(
  shipmentLocationWorksheetsState,
  state => state.cutOffResponse,
);

export const bigOrderQty = createSelector(
  selectCalendarResponse,
  state => _safe( () => state.bigOrder.quantity, null),
);
